<div class="tcd-container">
  <app-title-container backPath="treaty-assessments">
    <h1>Bordereau with Insured Names</h1>
    <div class="title-right" right>
      <button
        class="export-button"
        mat-icon-button
        (click)="exportExcel()"
        aria-label="Export icon button"
        matTooltip="Export to excel"
        [disabled]="isLoadingExport()"
      >
        @if (isLoadingExport()) {
          <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon>
        } @else {
          <span class="material-symbols-outlined"> file_export </span>
        }
      </button>
      <button mat-flat-button (click)="createReferral()"><mat-icon>add</mat-icon> Create Referral</button>
    </div>
  </app-title-container>

  @if (isLoading()) {
    <app-divider height="2px"></app-divider>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    @if (treatyState() === treatyStateEnum.IN_PROGRESS) {
      <div class="tcd-tab-content">
        <h3 class="text-green">Analysis in progress - please wait up to 5 minutes</h3>
      </div>
    }
  } @else if (treatyState() === treatyStateEnum.ERROR) {
    <app-divider height="2px"></app-divider>
    <div class="tcd-tab-content">
      <h3 class="text-red">Something happened, create new Bordereau Assessment or contact support team</h3>
    </div>
  } @else if (casualtyWithStats()) {
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Data">
        <div class="tcd-tab-content">
          <app-treaty-table
            [colDefs]="casualtyColDefs"
            [defaultColDef]="casualtyDefaultColDef"
            [rowData]="casualtyWithStats()!.data"
          ></app-treaty-table>
        </div>
      </mat-tab>
      <mat-tab label="Limit statistics">
        <div class="tcd-tab-content">
          <app-treaty-stats-detail [treatyStats]="casualtyWithStats()!.limitStats"></app-treaty-stats-detail>
        </div>
      </mat-tab>
      <mat-tab label="Premium statistics">
        <div class="tcd-tab-content">
          <app-treaty-stats-detail [treatyStats]="casualtyWithStats()!.premiumStats"></app-treaty-stats-detail>
        </div>
      </mat-tab>
    </mat-tab-group>
  }
</div>
